import { v4 as uuid } from 'uuid';
import { eMortgageDocumentType } from './eMortgageDocumentType';
import { DateTime } from 'luxon';

export interface IMortgageDocumentResponse {
  id: string;
  created_at?: string;
  mortgage_document_type?: eMortgageDocumentType | null;
  other_mortgage_document_type?: string | null;
  grantee_name?: string | null;
  grantor_name?: string | null;
  original_date?: string | null;
  recorded_date?: string | null;
  instrument_number?: string | null;
  book?: string | null;
  additional_information?: string | null;
}

export interface IMortgageDocumentData {
  id: string;
  createdAt?: string;
  mortgageDocumentType?: eMortgageDocumentType | null;
  otherMortgageDocumentType?: string | null;
  granteeName?: string | null;
  grantorName?: string | null;
  originalDate?: string | null;
  recordedDate?: string | null;
  instrumentNumber?: string | null;
  book?: string | null;
  additionalInformation?: string | null;
}

export const createDefaultMortgageDocumentData = (): IMortgageDocumentData => ({
  id: uuid(),
  createdAt: DateTime.local().toISO(),
});

export const convertMortgageDocumentResponseToMortgageDocumentData = (
  res: IMortgageDocumentResponse
): IMortgageDocumentData => ({
  id: res.id,
  createdAt: res.created_at,
  mortgageDocumentType: res.mortgage_document_type,
  otherMortgageDocumentType: res.other_mortgage_document_type,
  granteeName: res.grantee_name,
  grantorName: res.grantor_name,
  originalDate: res.original_date,
  recordedDate: res.recorded_date,
  instrumentNumber: res.instrument_number,
  book: res.book,
  additionalInformation: res.additional_information,
});

export const convertMortgageDocumentDataToMortgageDocumentResponse = (
  data: IMortgageDocumentData
): IMortgageDocumentResponse => ({
  id: data.id,
  created_at: data.createdAt,
  mortgage_document_type: data.mortgageDocumentType,
  other_mortgage_document_type: data.otherMortgageDocumentType,
  grantee_name: data.granteeName,
  grantor_name: data.grantorName,
  original_date: data.originalDate,
  recorded_date: data.recordedDate,
  instrument_number: data.instrumentNumber,
  book: data.book,
  additional_information: data.additionalInformation,
});
